import { Component, effect, inject, signal, ViewEncapsulation } from '@angular/core';
import { AnalyticsService, WidgetData } from '../../../../../core/services/analytics.service';
import { BaseComponent } from '../../../../../core/shared/common/base.component';
import { filter, switchMap } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MetricCardComponent } from '../../../../../core/components/metric-card';
import { CommonModule } from '@angular/common';
import { getThisWeekDateRange } from '../../../../../core/shared/common/date-range.util';

@Component({
  selector: 'app-new-tickets-widget',
  standalone: true,
  imports: [MetricCardComponent, CommonModule],
  templateUrl: './new-tickets-widget.component.html',
  styleUrl: './new-tickets-widget.component.scss',
  providers: [AnalyticsService],
})
export class NewTicketsWidgetComponent extends BaseComponent {
  private route = inject(ActivatedRoute);
  private analyticsService = inject(AnalyticsService);

  public newTicketData = signal<WidgetData>({ value: 0, colors: [] });
  public isLoading = signal<boolean>(true);
  public cardTitle = 'New';
  public suffix = '';

  constructor() {
    super();
    this.initEffect();
  }

  private initEffect() {
    effect(() => {
      this.route.queryParams
        .pipe(
          filter((params) => {
            return !!params['organizationId'];
          }),
          switchMap((params) => {
            const dateRange = getThisWeekDateRange();
            return this.analyticsService.getNewTickets(params['organizationId'], dateRange);
          })
        )
        .subscribe({
          next: (data) => {
            this.newTicketData.set(data);
            this.isLoading.set(false);
          },
          error: (error) => {
            console.error(error);
            this.isLoading.set(false);
          },
        });
    });
  }
}
